import { styled } from '@linaria/react';

export const Root = styled.div`
  display: flex;
  min-width: 280px;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  /* padding-bottom: 100px; */

  @media (width <= 320px) {
    padding: 8px;
    /* padding-bottom: 100px; */
  }
`;
